var map = {
	"./Gestion_AI_icon.svg": "doTq",
	"./Gestion_dual_hora_fija_icon.svg": "nMfP",
	"./Gestion_icon.svg": "WkQ0",
	"./Target_icon.svg": "aJgo",
	"./arrow-transf.svg": "rRN0",
	"./assign-chat-icon.svg": "spAC",
	"./bot-step-1.png": "Vfzh",
	"./bot-step-2.png": "qaVQ",
	"./bot-step-3.png": "RmsR",
	"./bot-step-4.png": "jmxH",
	"./bot-step-5.png": "8P2N",
	"./bot-step-6.png": "pJHo",
	"./bot-step-7.png": "69Hb",
	"./bot-step-8.png": "OhS5",
	"./call_center_wait_logo.svg": "XUob",
	"./colektia.png": "kOCa",
	"./colektia_red.png": "kWsS",
	"./date_mod_icon.svg": "axTI",
	"./filters_icon.svg": "643V",
	"./loader.gif": "M7I8",
	"./logo-login.png": "OwLT",
	"./logo-maintenance.png": "K93w",
	"./prioridad_III_icon.svg": "w7N+",
	"./prioridad_II_icon.svg": "uUvN",
	"./prioridad_I_icon.svg": "0fEA",
	"./vpn-disconnected.png": "yc/j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 11